module.exports = __webpack_public_path__ + "static/img/case_pro1.ca18354.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case_pro1.png
// module id = gtWn
// module chunks = 1